<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            {{$t("ventaDeProductosPorNegocio")}}
                        </li>
                    </ol>
                </nav>
            </div>

      <CabeceraInformes
        v-if="sectores && $cookies.isKey('sectores')"
        :idBusiness="idBusiness"
        :listBusinesses="listBusinesses"
        :listSectores="listaSectores"
        :idSector="idSector"
        :idTpv="idTpv"
        :listTpv="listTpv"
        :dateto="dateto"
        :datefrom="datefrom"
        id="cabecera"
        :conTodos="true"
        :sectores="true"
      />
      <CabeceraInformes
        v-else
        :idBusiness="idBusiness"
        :listBusinesses="listBusinesses"
        :idTpv="idTpv"
        :listTpv="listTpv"
        :dateto="dateto"
        :datefrom="datefrom"
        id="cabecera"
        :conTodos="true"
      />
      <template v-if="!permiso">
        <div class="alert alert-danger m-3" style="width: 100%" role="alert">
            Lo sentimos. Este negocio no cuenta con este módulo activado.
        </div>
      </template>
      <div class="col-md-8" v-else-if="respuesta">

        
        <template v-if="list.length > 0">
          <div class="row justify-content-between div-export">
            <div class="col-md-2 col-xs-12 text-right">
              <el-dropdown>
                <el-button type="primary" size="small">
                  <i class="fa fa-file"></i>
                  {{ $t("exportarInforme") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>  
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <a :href="urlExportPDF">
                    <el-dropdown-item class="text-danger">
                      <strong
                        ><i class="fa fa-file-pdf"></i>
                        {{ $t("exportarPdf") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                  <a :href="urlExportExcel">
                    <el-dropdown-item class="text-success">
                      <strong
                        ><i class="fa fa-file-excel"></i>
                        {{ $t("exportarExcel") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
              <div class="col-md-5" v-if="hayMenus">
                <label style="font-size:0.8em">
                  <strong>{{ $t('excluirPrecioMedioMenu') }}</strong>
                </label>

                <el-switch 
                  v-model="excluirMenu"
                  active-color="#13ce66"
                  inactive-color="#bcbcbc"
                >
                </el-switch>
              </div>
              <div class="col-md-4">
                <label style="font-size:0.8em">
                  <strong>{{ $t("ocultarSaldo") }}</strong>
                </label>

                <el-switch 
                  v-model="checkValue"
                  active-color="#13ce66"
                  inactive-color="#bcbcbc"
                  @change="getSalesProducts()"
                >
                </el-switch>
              </div>

          </div>
          
          <div class="table-responsive">
            <table class="table table-bordered table-striped text-nowrap">
              <thead class="thead-dark">
                <tr style="cursor: pointer;">
                  <th
                    v-if="ordenacionProductos === 0" @click="sortedArrayNameASC('name')">
                    <i style="color: white" class="fa fa-angle-up"></i>
                    {{ $t("producto") }}
                  </th>
                  <th v-else @click="sortedArrayNameDESC('name')">
                    <i style="color: white" class="fa fa-angle-down"></i>
                    {{ $t("producto") }}
                  </th>
                  <th v-if="ordenarBarcode === 0" @click="sortedArrayBarcodeASC('barcode')">
                    <i style="color: white" class="fa fa-angle-up"></i>
                    {{ $t("codigoDeBarra") }}
                  </th>
                  <th v-else @click="sortedArrayBarcodeDESC('barcode')">
                    <i style="color: white" class="fa fa-angle-down"></i>
                    {{ $t("codigoDeBarra") }}
                  </th>
                  <template v-if="hasPLUAccess">
                    <th v-if="ordenarPLU === 0" @click="sortedArrayPLUASC('plu')">
                      <i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("PLU") }}
                    </th>
                    <th v-else @click="sortedArrayPLUDESC('plu')">
                      <i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("PLU") }}
                    </th>
                  </template>
                  <th v-if="ordenarCantidad === 0" @click="sortedArrayCantidadASC('cantidad')">
                    <i style="color: white" class="fa fa-angle-up"></i>
                    {{ $t("cantidad") }}
                  </th>
                  <th v-else @click="sortedArrayCantidadDESC('cantidad')">
                    <i style="color: white" class="fa fa-angle-down"></i>
                    {{ $t("cantidad") }}
                  </th>
                  <template v-if="hayMenus">
                    <th
                      v-if="ordenarCantidadMenu === 0"
                      @click="sortedArrayCantidadMenuASC('cantidadMenu')" v-tooltip.top-center="'Cantidad en menús'"
                    >
                      <i style="color: white" class="fa fa-angle-up"></i>
                      C. en Menús
                    </th>
                    <th v-else @click="sortedArrayCantidadMenuDESC('cantidadMenu')"  v-tooltip.top-center="'Cantidad en menús'">
                      <i style="color: white" class="fa fa-angle-down"></i>
                      C. en Menús
                    </th>
                    <th
                      v-if="ordenarCantidadMenuDiferencia === 0"
                      @click="sortedArrayCantidadMenuDiferenciaASC('cantidadDiferencia')"  v-tooltip.top-center="'Cantidad fuera de menús'"
                    >
                      <i style="color: white" class="fa fa-angle-up"></i>
                        C. Fuera de Menús
                    </th>
                    <th v-else @click="sortedArrayCantidadMenuDiferenciaDESC('cantidadDiferencia')" v-tooltip.top-center="'Cantidad fuera de menús'">
                      <i style="color: white" class="fa fa-angle-down"></i>
                        C. Fuera de Menús
                    </th>
                  </template>
                  <th
                    v-if="ordenarImporte === 0"
                    @click="sortedArrayImporteASC('importe')"
                  >
                    <i style="color: white" class="fa fa-angle-up"></i>
                    {{ $t("importe") }}
                  </th>
                  <th v-else @click="sortedArrayImporteDESC('importe')">
                    <i style="color: white" class="fa fa-angle-down"></i>
                    {{ $t("importe") }}
                  </th>
                  <th
                    v-if="ordenarPrecioMed === 0"
                    @click="sortedArrayPrecioMedASC('importe/cantidad')"
                  >
                    <i style="color: white" class="fa fa-angle-up"></i>
                    {{ $t("precioMed") }}
                  </th>
                  <th
                    v-else
                    @click="sortedArrayPrecioMedDESC('importe/cantidad')"
                  >
                    <i style="color: white" class="fa fa-angle-down"></i>
                    {{ $t("precioMed") }}
                  </th>
                  <th @click="sortedArrayRentabilidad()" v-tooltip.top-center="$t('rentabilidadInfo')">
                    <i style="color: white" :class="ordenarRentabilidad === 0 ? 'fa fa-angle-up' : 'fa fa-angle-down'"></i>
                    {{ $t("rentabilidad") }}
                  </th>
                  <th
                    v-if="ordenarImporte === 0"
                    @click="sortedArrayImporteASC('importe')"
                  >
                    <i style="color: white" class="fa fa-angle-up"></i>
                    {{ $t("importeSinIva") }}
                  </th>
                  <th v-else @click="sortedArrayImporteDESC('importe')">
                    <i style="color: white" class="fa fa-angle-down"></i>
                    {{ $t("importeSinIva") }}
                  </th>
                  <th >
                    <i style="color: white" ></i>
                    {{ $t("acciones") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="obj in list" :key="obj.id">
                  <td style="width:35%"><span style="color:#458195; cursor: pointer;" v-if="obj.menusPertenecientes.length > 0" @click="abrirModalDetallesMenu(obj)">⠀<i class="fas fa-list" style="font-weight: bold; font-size: 1.1em"></i>⠀{{obj.name}}</span><span v-else>{{obj.name}}</span> </td>
                  <td style="width:10%" class="text-right">
                    <span>{{ obj.barCode }}</span>
                  </td>
                  <template v-if="hasPLUAccess">
                    <td style="width:10%" class="text-right">
                      <span>{{ obj.PLU }}</span>
                    </td>
                  </template>
                  <td style="width:10%" class="text-right">
                    <span class="text-primary"
                      v-if="obj.pedirPeso">{{ Math.round(obj.cantidad) }} Kg.</span
                    >
                    <span v-else class="text-right">{{ Math.round(obj.cantidad) }}</span>
                  </td>
                  <template v-if="hayMenus">
                    <td style="width:10%" class="text-right">
                      <span class="text-primary"
                        v-if="obj.pedirPeso">{{ obj.cantidadMenu }} Kg.</span
                      >
                      <span v-else class="text-righ">{{obj.cantidadMenu}}</span>
                    </td>
                    <td style="width:15%" class="text-right">
                      <span class="text-primary"
                        v-if="obj.pedirPeso">{{ obj.cantidad - obj.cantidadMenu }} Kg.</span
                      >
                      <span v-else class="text-righ">{{obj.cantidad - obj.cantidadMenu}}</span>
                    </td>
                  </template>
                  <td class="text-right" style="width:10%">{{ obj.importe | currency }}</td>
                  <td class="text-right" style="width:10%">
                    {{ calcularMedia(obj) | currency }}
                  </td>
                  <td class="text-right" style="width:10%">
                    <span v-if="tieneCoste(obj)" style="white-space: nowrap">
                      {{ calcularRentabilidad(obj) | currency }}
                      <span v-if="calcularRentabilidad(obj) > 0" style="color: #28a745">&#9650;</span>
                      <span v-else-if="calcularRentabilidad(obj) < 0" style="color: #dc3545">&#9660;</span>
                    </span>
                    <span v-else class="text-muted" v-tooltip.top-center="$t('sinPrecioDeCoste')">-</span>
                  </td>
                  <td class="text-right" style="width:10%">{{ obj.importeSinIva | currency }}</td>
                  <td class="text-center" style="width:6%">
                    <router-link
                      v-if="Number(obj.idProduct) > 0"
                      :to="buildRutaOperario(obj)"
                      aria-label="Listado de productos por operario"
                    >
                      <i class="fa fa-eye" style="cursor: pointer;" v-tooltip.top-center="$t('listadoProductosOperario')"></i>
                    </router-link>
                    <i v-else class="fa fa-eye text-muted" v-tooltip.top-center="$t('sinIdDeProducto')"></i>
                  </td>

                </tr>
              </tbody>
              <tfoot>
                <tr class="table-success">
                  <td>
                    <strong>{{ $t("total") }}</strong>
                  </td>
                  <td></td>
                  <template v-if="hasPLUAccess">
                    <td></td>
                  </template>
                  <td class="text-right">
                    <strong>{{ getTotalUds }}</strong>
                    <i v-tooltip.top-center="$t('recuerdeQueLasLineasDeDescuentoNoSeSumanAlTotal')"
                      style="cursor: pointer;"
                      class="fa fa-info-circle">
                    </i>
                  </td>
                  <template v-if="hayMenus">
                    <td class="text-right">
                      <strong>{{ getTotalUdsMenus }}</strong>
                    </td>
                    <td class="text-right">
                      <strong>{{ getTotalUds - getTotalUdsMenus }}</strong>
                    </td>
                  </template>
                  <td class="text-right">
                    <strong>{{ getTotalPrecio | currency }}</strong>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </template>
        <template v-else>
          <div class="alert alert-danger" role="alert">
            {{ $t("noHayVentasDeProductosEnEsteRangoDeFechas") }}
          </div>
        </template>
      </div>

      <!-- <div class="col-md-4 " v-show="this.list.length > 0 && respuesta && permiso">
        <div class="card">
          <button
            v
            v-if="chartIn === 0"
            @click="(chartIn = 1), initChart()"
            class="btn btn-primary col-md-12"
          >
            {{ $t("porUnidad") }}
          </button>
          <button
            v-else
            @click="(chartIn = 0), initChart()"
            class="btn btn-primary col-md-12"
          >
            {{ $t("porImporte") }}
          </button>

          <div
            class="chart-container col-md-12"
            style="height:300px; width: 100%"
          >
            <canvas id="chart"></canvas>
          </div>
        </div>
      </div>  -->
      <modal
      name="detallesMenu"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="true"
      >
      <div>
          <div class="modal-header">
          <h5 style="margin: 0px">
              Veces que se ha vendido dentro de menús
          </h5>
          </div>
          <div class="modal-body">
          <div
              class="table-responsive"
              style="overflow: auto"
          >
              <table class="table table-bordered table-striped ">
              <thead class="thead-dark">
                  <tr>
                  <th style="width:90%">{{ $t("nombre") }} del menú</th>
                  <th>{{ $t("cantidad") }}</th>
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="(prod) in listaDetallesMenu" :key="prod.id + Math.random()">
                      <td>{{prod.name}}</td>
                      <td>{{prod.cantidad}}</td>
                  </tr>
              </tbody>
              <tfoot>
                  <tr></tr>
              </tfoot>
              </table>
          </div>
          </div>
          <div class="modal-footer">
          <button class="btn btn-default" @click="cerrarModalDetallesMenu()">
              <i class="fa fa-times-circle"></i>
              {{ $t("cerrar") }}
          </button>
          </div>
      </div>
      </modal>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Chart from "chart.js";
import {
  DatePicker,
  Select,
  Switch,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Loading,
  Checkbox,
  CheckboxGroup,
} from "element-ui";
import { mapState, mapMutations } from 'vuex';
import swal from "sweetalert2";
import moment from "moment";
import CabeceraInformes from "../../../../components/CabeceraInformes/CabeceraInformes.vue";
import bus from "../../../../bus";
import Vuex from "vuex";

export default {
  created() {
    this.loading = Loading.service({ text: "Cargando..." });;
    this.$store.dispatch("setNameRoute", this.$i18n.t("ventasDeProductos"));
    if (!this.sectores && !this.$cookies.isKey("sectores")) {
      this.getBusiness();
    } else {
      if (this.listaSectores.length > 1) {

          this.idSector = this.listaSectores[0].id;

          //Dentro, establecer un todos como primera opción y después llamar a getTpv()
          this.getBusinessesBySector();
      } else {

          //Cargar método local donde me traigo los sectores
          this.getSectores();

      }
    }
    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }

  },
  components: {
    CabeceraInformes,
    [DatePicker.name]: DatePicker,
    [Switch.name]: Switch,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
  },
  data() {
    return {
      loading: false,
      //datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
      //dateto: new Date().toISOString(),
      //listBusinesses: [],
      //idBusiness: 0,
      //idTpv: 0,
      idBusiness: this.$route.params.idBusiness,
      listBusinesses: [],
      idTpv: 0,
      dateto: new Date().toISOString(),
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      list: [],
      mode: 0,
      $Chart: null,
      objectChart: null,
      contador: 0,
      chartIn: 0,
      listTpv: [],
      listIdTpv: [],
      dateRangeOptions1: {
        firstDayOfWeek: 1,
      },
      listCheckBoxTpv: [],
      idsTPV: [],
      respuesta: false,
      ordenacionProductos: 0,
      ordenarBarcode: 0,
      ordenarPLU: 0,
      ordenarCantidad: 0,
      ordenarCantidadMenu: 0,
      ordenarCantidadMenuDiferencia: 0,
      ordenarImporte: 0,
      ordenarPrecioMed: 0,
      ordenarRentabilidad: 0,
      excluirMenu: false,
      checkValue:false,
      hayMenus: false,
      listaDetallesMenu: [],
      hasPLUAccess: false,
    };
  },
  computed: {
    ...mapState(["listaSectores", "sectores", "permiso"]),
    urlExportPDF() {
      let idBusiness = this.idBusiness;
      let sector = 0;

      let idTpv = this.idTpv == -1 ? this.listIdTpv : [this.idTpv];
      
      if (this.sectores && this.$cookies.isKey('sectores')) {
        idTpv = this.idsTPV;

        if (this.idBusiness == -1) {
          idBusiness = this.listaSectores.find((sector) => sector.id == this.idSector).idBusinessMaster;
          sector = this.listaSectores.find((sector) => sector.id == this.idSector).name;
        }
      }

      let url = this.$store.getters.apiUrl +
        "/products/exportVentasProduct/PDF?idBusiness=" +
        idBusiness +
        "&idTpv=" +
        idTpv +
        "&checkValue=" +
        this.checkValue +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt;

      if (sector != 0) {
        url += "&sector="+sector;
      }

      return (
        url
      );
    },

    urlExportExcel() {
      
      let idBusiness = this.idBusiness;
      let sector = 0;

      let idTpv = this.idTpv == -1 ? this.listIdTpv : [this.idTpv];
      
      if (this.sectores && this.$cookies.isKey('sectores')) {
        idTpv = this.idsTPV;

        if (this.idBusiness == -1) {
          idBusiness = this.listaSectores.find((sector) => sector.id == this.idSector).idBusinessMaster;
          sector = this.listaSectores.find((sector) => sector.id == this.idSector).name;
        }
      }

      let url = this.$store.getters.apiUrl +
        "/products/exportVentasProduct/Excel?idBusiness=" +
        idBusiness +
        "&idTpv=" +
        idTpv +
        "&checkValue=" +
        this.checkValue +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt;
      
      if (sector != 0) {
        url += "&sector="+sector;
      }
      
      return (
        url
      );
    },

    getTotalPrecio() {
      let total = 0;
      this.list.forEach(function(d) {
        total += d.importe;
      });
      return total;
    },

    getTotalUds() {
      let total = 0;
      const patron = /.*Dto$/;

      this.list.forEach(function(d) {
        if (d.name != "Descuento" && !d.name.match(patron)) {
          total += d.cantidad;
        }
      });
      return total;
    },
    getTotalUdsMenus() {
      let total = 0;
      this.list.forEach(function(d) {
        if (d.name != "Descuento") {
          total += parseFloat(d.cantidadMenu);
        }
      });
      return total;
    },
  },
  methods: {
    ...Vuex.mapMutations(["changeRespuesta", 'changeListaSectores']),

    // PLU ACCESS
    checkBusinessPermissions() {

        var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusiness: this.idBusiness,
          numConfig: 117
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        //.get(this.$store.getters.apiUrl + "general/getConfigByUser", config)

        .then(function(response) {
          if (response.data.response) {
            vm.hasPLUAccess = response.data.result;
          }
          vm.loading.close();
        })
        .catch(function(error) {
          console.error('Error al verificar permisos:', error);
          // En caso de error, se asume que no tiene acceso
          vm.hasPLUAccess = false; 
        });
  },
    abrirModalDetallesMenu(obj) {
      this.listaDetallesMenu = obj.menusPertenecientes;
      this.$modal.show('detallesMenu');
    },

    cambioSector(idSectorData, listBusinesses) {
      if (listBusinesses) {
        this.listBusinesses = listBusinesses;
      }

      this.idSector = idSectorData;
      this.idBusiness = -1; 
      this.getAllTpvFromBusinesses();
    },
    cerrarModalDetallesMenu() {
      this.$modal.hide('detallesMenu');
      this.listaDetallesMenu = [];
    },
    sortedArrayNameASC: function() {
      this.ordenacionProductos = 1;

      function compare(a, b) {
        if (a.name.toUpperCase() < b.name.toUpperCase()) return -1;
        if (a.name.toUpperCase() > b.name.toUpperCase()) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayNameDESC: function() {
      this.ordenacionProductos = 0;

      function compare(a, b) {
        if (a.name.toUpperCase() > b.name.toUpperCase()) return -1;
        if (a.name.toUpperCase() < b.name.toUpperCase()) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayBarcodeASC: function() {
      this.ordenarBarcode = 1;

      function compare(a, b) {
        if (a.barCode < b.barCode) return -1;
        if (a.barCode > b.barCode) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayBarcodeDESC: function() {
      this.ordenarBarcode = 0;

      function compare(a, b) {
        if (a.barCode > b.barCode) return -1;
        if (a.barCode < b.barCode) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayPLUASC: function() {
        this.ordenarPLU = 1;

        function compare(a, b) {
            if (a.PLU < b.PLU) return -1;
            if (a.PLU > b.PLU) return 1;
            return 0;
        }

        return this.list.sort(compare);
    },
    sortedArrayPLUDESC: function() {
        this.ordenarPLU = 0;

        function compare(a, b) {
            if (a.PLU > b.PLU) return -1;
            if (a.PLU < b.PLU) return 1;
            return 0;
        }

        return this.list.sort(compare);
    },
    sortedArrayCantidadASC: function() {
      this.ordenarCantidad = 1;

      function compare(a, b) {
        if (a.cantidad < b.cantidad) return -1;
        if (a.cantidad > b.cantidad) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayCantidadDESC: function() {
      this.ordenarCantidad = 0;

      function compare(a, b) {
        if (a.cantidad > b.cantidad) return -1;
        if (a.cantidad < b.cantidad) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayCantidadMenuASC: function() {
      this.ordenarCantidadMenu = 1;

      function compare(a, b) {
        if (a.cantidadMenu < b.cantidadMenu) return -1;
        if (a.cantidadMenu > b.cantidadMenu) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayCantidadMenuDESC: function() {
      this.ordenarCantidadMenu = 0;

      function compare(a, b) {
        if (a.cantidadMenu > b.cantidadMenu) return -1;
        if (a.cantidadMenu < b.cantidadMenu) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayCantidadMenuDiferenciaASC: function() {
      this.ordenarCantidadMenuDiferencia = 1;

      function compare(a, b) {
        if ((a.cantidad - a.cantidadMenu) < (b.cantidad - b.cantidadMenu)) return -1;
        if ((a.cantidad - a.cantidadMenu) > (b.cantidad - b.cantidadMenu)) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayCantidadMenuDiferenciaDESC: function() {
      this.ordenarCantidadMenuDiferencia = 0;

      function compare(a, b) {
        if ((a.cantidad - a.cantidadMenu) > (b.cantidad - b.cantidadMenu)) return -1;
        if ((a.cantidad - a.cantidadMenu) < (b.cantidad - b.cantidadMenu)) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayImporteASC: function() {
      this.ordenarImporte = 1;

      function compare(a, b) {
        if (a.importe < b.importe) return -1;
        if (a.importe > b.importe) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayImporteDESC: function() {
      this.ordenarImporte = 0;

      function compare(a, b) {
        if (a.importe > b.importe) return -1;
        if (a.importe < b.importe) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayPrecioMedASC: function() {
      this.ordenarPrecioMed = 1;

      function compare(a, b) {
        if (a.importe / a.cantidad < b.importe / b.cantidad) return -1;
        if (a.importe / a.cantidad > b.importe / b.cantidad) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayPrecioMedDESC: function() {
      this.ordenarPrecioMed = 0;

      function compare(a, b) {
        if (a.importe / a.cantidad > b.importe / b.cantidad) return -1;
        if (a.importe / a.cantidad < b.importe / b.cantidad) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    // openModal() {
    //
    //     this.$modal.show('filtradoTPV');
    //
    // },
    cambioBusiness(idBusinessData, listTpv) {
      if (listTpv) {
        this.listTpv = listTpv;
        this.listIdTpv = [];

        listTpv.forEach(element => {
            this.listIdTpv.push(element.id);
        });
      }
      this.loading = Loading.service({ text: "Cargando..." });
      this.idBusiness = idBusinessData;
      this.idTpv = -1;
      this.list = [];
      this.idsTPV = [];

      if ((!this.sectores && !this.$cookies.isKey("sectores")) || idBusinessData != -1) {
        this.cambioTpv(this.idTpv);
      } else {
        this.getAllTpvFromBusinesses();
      }

      this.checkBusinessPermissions()
    },
    emitirConsulta() {
      this.getSalesProducts();
    },
    cambioTpv(idTpvData, filtrar) {
      this.idTpv = idTpvData;

      if (idTpvData != undefined) {
        this.changeTPV();
      }

      this.emitirConsulta();
    },
    changeTPV() {
      if (this.idTpv === -1) {
        this.idsTPV = [];

        for (let i = 0; i < this.listTpv.length; i++) {
          this.idsTPV.push(this.listTpv[i].id);
        }
      } else {
        this.idsTPV = [];
        this.idsTPV.push(this.idTpv);
      }
    },
    cambioHora(dates) {
      this.datefrom = dates[0];
      this.dateto = dates[1];
    },

    getTpv() {
      this.listTpv = [];
      this.listIdTpv = [];
      this.idsTPV = [];
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function(response) {
          if (response.data.response) {
            vm.idsTPV = [];
            for (let i = 0; i < response.data.result.length; i++) {
              vm.idsTPV.push(response.data.result[i].id);
            }

            vm.listCheckBoxTpv = response.data.result;

            let printer = {
              nameShow: vm.$t("todos"),
              id: 0,
            };
            vm.listTpv.push(printer);

            for (let i = 0; i < response.data.result.length; i++) {
              let printername = {
                nameShow: response.data.result[i].nameShow,
                id: response.data.result[i].id,
              };

              vm.listTpv.push(printername);

              vm.listIdTpv.push(response.data.result[i].id);
            }

            vm.getSalesProducts();
          }
          vm.loading.close();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.cambioTpv(-1, false);

          vm.checkBusinessPermissions();

        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getSalesProducts() {
      
      var ocultarProSaldo=0

      if(this.checkValue==true){
        ocultarProSaldo = 1
      }

      this.$modal.hide("filtradoTPV");

      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.loading = Loading.service({ text: "Cargando..." });;

          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          let listaTPVs = this.idTpv == -1 ? this.listIdTpv : [this.idTpv];

          if (this.sectores && this.$cookies.isKey('sectores')) {
            listaTPVs = this.idsTPV;
          }

          var config = {
            params: {
              idBusiness: this.idBusiness == -1 ? this.listaSectores[0].idBusinessMaster : this.idBusiness,
              ocultarProSaldo : ocultarProSaldo,
              datefrom: moment(this.datefrom)
                .startOf("day")
                .unix(),
              dateto: moment(this.dateto)
                .endOf("day")
                .unix(),
              idTpv: listaTPVs,
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;

          if (this.idBusiness != -1 || !this.sectores && !this.$cookies.isKey('sectores')) {
            this.$store.dispatch("setIdBusiness", this.idBusiness);
          }

          this.axios
            .get(
              this.$store.getters.apiUrl + "products/getSalesProducts",
              config
            )
            .then(function(response) {
              if (response.data.response) {
                vm.changeRespuesta(true);

                vm.list = response.data.result;

                vm.hayMenus = vm.list.some(element => element.isMenu);

                vm.initChart();

                vm.respuesta = true;
              }else if (response.data.response == false && response.data.rangoMayor == true) {
                    swal({
                      title: "Lo sentimos",
                      text: response.data.result,
                      confirmButtonClass: "btn btn-info btn-fill",
                      type: "info",
                    });
                    vm.respuesta = false;
              } 
              else {
                swal({
                  title: vm.$t("accesoDenegado"),
                  text: vm.$t("noTienesPermisoParaVisualizarEsteInforme"),
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
                vm.respuesta = false;
              }
              vm.loading.close();
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      }
    },
    tieneCoste(obj) {
      return Number(obj.idProduct) > 0 && Number(obj.costeUnitario) > 0;
    },
    // Rentabilidad = precio medio (columna "Precio med.") - coste de sus materias primas
    calcularRentabilidad(obj) {
      return this.calcularMedia(obj) - (Number(obj.costeUnitario) || 0);
    },
    sortedArrayRentabilidad() {
      const signo = this.ordenarRentabilidad === 0 ? 1 : -1;
      this.ordenarRentabilidad = this.ordenarRentabilidad === 0 ? 1 : 0;
      const valor = (obj) => (this.tieneCoste(obj) ? this.calcularRentabilidad(obj) : -Infinity);
      this.list.sort((a, b) => {
        const va = valor(a);
        const vb = valor(b);
        if (va === vb) return 0;
        return (va < vb ? -1 : 1) * signo;
      });
    },
    calcularMedia(obj) {
      let media = 0;
      
      if (this.excluirMenu) {
        media =  obj.importe / (obj.cantidad - obj.cantidadMenu);
      } else {
        media = obj.importe / obj.cantidad;
      }

      return media;
    },
    initChart() {
      if (this.chartIn === 0) {
        var labels = this.list.map(function(x) {
          return x.name;
        });

        var data = this.list.map(function(x) {
          return x.cantidad;
        });
      } else {
        var labels = this.list.map(function(x) {
          return x.name;
        });

        var data = this.list.map(function(x) {
          return x.importe;
        });
      }

      var randomColor = require("randomcolor");

      var colors = randomColor({
        luminosity: "dark",
        count: labels.length,
        format: "rgb",
      });

      let backgroundColors = colors.map(function(x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)"
        );
      });

      let borderColors = colors.map(function(x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.3)"
        );
      });

      let hoverBackgroundColors = colors.map(function(x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 1)"
        );
      });

      if (this.contador == 0) {
        if (this.list.length > 0) {
          this.objectChart = new Chart("chart", {
            type: "pie",
            data: {
              labels: labels,
              datasets: [
                {
                  data: data,
                  backgroundColor: backgroundColors,
                  borderColor: borderColors,
                  hoverBackgroundColor: hoverBackgroundColors,
                  borderWidth: 1,
                },
              ],
            },
            options: {
              legend: {
                display: false,
                position: "bottom",
              },
              maintainAspectRatio: false,
            },
          });

          this.contador++;
        }
      } else {
        this.objectChart.destroy();

        this.objectChart = new Chart("chart", {
          type: "pie",
          data: {
            labels: labels,
            datasets: [
              {
                data: data,
                backgroundColor: backgroundColors,
                borderColor: borderColors,
                hoverBackgroundColor: hoverBackgroundColors,
                borderWidth: 1,
              },
            ],
          },
          options: {
            legend: {
              display: false,
              position: "bottom",
            },
            maintainAspectRatio: false,
          },
        });
      }
    },
    getBusinessesBySector() {
      let config = {
          params: {
              jwt: this.$store.getters.jwt,
          },
          headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
      };

      var params = {
          idBusiness: this.listaSectores[0].idBusinessMaster,
          idSector: this.idSector,
          jwt: this.$store.getters.jwt,
      };

      let vm = this;
      this.axios.post(this.$store.getters.apiUrl + "general/getBusinessesBySector", params, config)
          .then(function (response) {

          if (response.data.response) {

              //Recojo todos los negocios de la carga inicial del sector seleccionado

              vm.listBusinesses = response.data.result;
              vm.idBusiness = -1;

              //Recojo todos los tpv
              vm.getAllTpvFromBusinesses();
              
          }

      }).catch(function (error) {
          console.log(error);
      })
    },
    getAllTpvFromBusinesses() {

      let businesses = [];

      this.listBusinesses.forEach(business => {

        if (business.id != -1) {
          businesses.push(parseInt(business.id));
        }
        
      });

      let config = {
          params: {
              jwt: this.$store.getters.jwt,
              idBusiness: businesses,
          },
          headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
      };

      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByListBusiness", config)
          .then(function (response) {

          if (response.data.response) {
              vm.listTpv = [];
              vm.idsTPV = [];

              for (let i = 0; i < response.data.result.length; i++) {
                vm.idsTPV.push(response.data.result[i].id);
              }

              //vm.idTpv = response.data.result[0].id;

              vm.listCheckBoxTpv = response.data.result;

              for (let i = 0; i < response.data.result.length; i++) {
                let printername = {
                  nameShow: response.data.result[i].nameShow,
                  id: response.data.result[i].id,
                };

                vm.listTpv.push(printername);
              }

              vm.getSalesProducts();
              vm.grafica = 0;
            }
            vm.loading.close();

      }).catch(function (error) {
          console.log(error);
      })
    },
    getSectores() {
      let config = {
          params: {
              jwt: this.$store.getters.jwt,
          },
          headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
      };

      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesSectors", config)
          .then(function (response) {

          if (response.data.response) {
              
              response.data.result["sectores"].forEach((sector) => {
                  sector.idBusinessMaster = parseInt(sector.idBusinessMaster);
                  sector.id = parseInt(sector.id);
              });
              
              vm.changeListaSectores(response.data.result["sectores"]);

              vm.idSector = vm.listaSectores[0].id;
              
              vm.getBusinessesBySector();
              
          }

      }).catch(function (error) {
          console.log(error);
      })
    },
buildRutaOperario: function (obj) {
  function toNumberStrict(val) {
    if (val === null || val === undefined) return null;
    if (typeof val === 'number') {
      return isNaN(val) ? null : val;
    }
    if (typeof val === 'string') {
      var s = val.trim();
      // acepta enteros positivos (si usas ids negativos, cambia el regex)
      if (/^\d+$/.test(s)) return parseInt(s, 10);
    }
    return null;
  }

  function pickFirstNumber(o, fields) {
    for (var i = 0; i < fields.length; i++) {
      var k = fields[i];
      if (o && o[k] !== undefined && o[k] !== null) {
        var n = toNumberStrict(o[k]);
        if (n !== null) return n;
      }
    }
    return null;
  }

  var idProducto = pickFirstNumber(obj || {}, [
    'idProduct', 'idProducto', 'productId', '__idProducto', 'id_product', 'IdProduct', 'IdProducto', 'id'
  ]);
  if (idProducto === null) idProducto = 0;

  var productName = (obj && (obj.name || obj.productName)) ? (obj.name || obj.productName) : '';
  var barCode     = (obj && (obj.barCode || obj.codigoBarra)) ? (obj.barCode || obj.codigoBarra) : '';
  var PLU         = (obj && (obj.PLU || obj.plu)) ? (obj.PLU || obj.plu) : '';
  var pedirPeso   = !!(obj && obj.pedirPeso);

  var idBusinessForRoute = this.idBusiness;
  if (this.sectores && this.$cookies.isKey('sectores') && this.idBusiness === -1) {
    var sel = null;
    for (var j = 0; j < this.listaSectores.length; j++) {
      if (String(this.listaSectores[j].id) === String(this.idSector)) {
        sel = this.listaSectores[j];
        break;
      }
    }
    if (sel && sel.idBusinessMaster) idBusinessForRoute = Number(sel.idBusinessMaster);
  }

  var tpvs;
  if (this.sectores && this.$cookies.isKey('sectores')) {
    tpvs = this.idsTPV || [];
  } else {
    tpvs = (this.idTpv === -1) ? (this.listIdTpv || []) : [this.idTpv];
  }

  // -------- 5) Fechas a UNIX (inicio/fin de día) ----------
  var datefrom = moment(this.datefrom).startOf('day').unix();
  var dateto   = moment(this.dateto).endOf('day').unix();

  // -------- 6) Switches/flags del origen ----------
  var checkValueFlag  = this.checkValue ? 1 : 0;   // ocultar saldo
  var excluirMenuFlag = this.excluirMenu ? 1 : 0;  // excluir precio medio menús

  // -------- 7) Aviso si no hay id de producto ----------
  if (!idProducto) {
    try { console.warn('[buildRutaOperario] idProducto ausente/0 para:', obj); } catch (e) {}
  }

  // -------- 8) Devuelve el objeto de ruta ----------
  return {
    name: 'productosPorOperario',
    params: {
      idBusiness: Number(idBusinessForRoute || 0),
      idProducto: Number(idProducto || 0)
    },
    query: {
      idTpv: JSON.stringify(tpvs || []),
      datefrom: datefrom,
      dateto: dateto,

      checkValue: checkValueFlag,
      excluirMenu: excluirMenuFlag,

      productName: productName,
      barCode: barCode,
      PLU: PLU,
      pedirPeso: pedirPeso ? 1 : 0,

      // redundancia por si el destino decide leerlo desde la query
      idProducto: Number(idProducto || 0)
    }
  };
}
,



  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}

body {
  background: #1d1f20;
  padding: 16px;
}

.chart-container {
  position: relative;
  margin: auto;
  height: 80vh;
  width: 80vw;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Productos/VentasProductos.vue